import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=55a92184&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=ts&setup=true"
export * from "./Feedback.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=55a92184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a92184",
  null
  
)

export default component.exports